import React, { PureComponent } from 'react';
import { Flex, Box } from 'reflexbox';
import * as d3Scale from 'd3-scale';
import * as d3Array from 'd3-array';

import { numberFormat } from '~/core/scripts/utils';

import { getColor } from '../../config';

const d3 = {
  ...d3Scale,
  ...d3Array
};

import './ResultRegio.styl';

const cleanName = (name) => {
  if (name === 'Die.Partei') {
    return 'Partei';
  }

  if (name === 'Die.Linke') {
    return 'Linke';
  }

  return name;
}

class BarChart extends PureComponent {
  render() {
    const currentData = this.props.data;
    const max = d3.max(currentData, d => Number(d.result));
    const height = d3.scaleLinear().domain([0, max]).range([0, 100]);

    return (
      <Flex className="regio-chart">
        {currentData.sort((a, b) => b.result - a.result).map(item => (
          <Flex className="regio-bar-wrapper" key={item.party} column justify="flex-end">
            <div className="regio-bar" style={{ height: height(item.result), backgroundColor: getColor(item.party) }} />
            <div className="regio-party" style={{color: getColor(item.party)}}>{cleanName(item.party)}</div>
            <div className="regio-result">{numberFormat(item.result, 1)}%</div>
          </Flex>
        ))}
      </Flex>
    );
  }
}

export default BarChart;
